import { io } from 'socket.io-client';

const token = localStorage.getItem(`${process.env.REACT_APP_COGNITO_CLIENT_ID}.accessToken`);

export const socket = io(process.env.REACT_APP_TNFT_SERVER, {
    path: "/appsock/socket.io",
    auth: { token },
    autoConnect: false,
    transports: ["websocket"],
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 2000,
    timeout: 5000,
});

